import CommonDateField, { CommonDateFieldProps } from "./CommonDateField";

export default CommonDateField;
export type { CommonDateFieldProps };
